export const SETUP_TITLE = "What needs attention";

export const SETUP_INTRO = "Review what changed. Fix what drifted. Remember every decision.";

export const CONNECT_GITHUB = "Connect GitHub";
export const MANAGE_ACCESS = "Manage repository access";
export const REVIEW_PULL_REQUEST = "Review a pull request";
export const ENABLE_CHECKS = "Enable GitHub Checks";
export const RETRY_PUBLICATION = "Retry publication";
export const CHOOSE_REPOSITORY = "Choose a repository";

export const VIEWER_NOTE = "Your role can view this workspace. An owner or admin connects GitHub and starts reviews.";

export const STEP_STATUS = {
  complete: "Complete",
  "needs-action": "Needs action",
  "in-progress": "In progress",
  degraded: "Degraded",
  optional: "Optional",
};
